import { ReactNode } from "react";
import { useMatch } from "react-router-dom";
import { ROUTES } from "constants/routes";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const isNFePage = useMatch(ROUTES.EMISSAO_NFE);

  return (
    <>
      {!isNFePage && <Header />}
      {children}
      {!isNFePage && <Footer />}
    </>
  );
};

export default Layout;
